import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RadiusUpleftOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusUpleftOutlined";
import AntdIcon from "../components/AntdIcon";
var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusUpleftOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
}
export default /*#__PURE__*/React.forwardRef(RadiusUpleftOutlined);